import { useCallback } from "react"
import { getSubmit } from "@ui-seeker/utils"
import { BACKEND_APIS } from "@constants"
import { slaveId, userData } from "@signals/user"
import { useSignal } from "@preact/signals-react"
import { tableData } from "Pages/Admin/Users/@signals"

export default function useAdminListTable() {

	const isTableLoading = useSignal(false)

	const getTableData = useCallback(() => {
		isTableLoading.value = true
		getSubmit(`${BACKEND_APIS.MASTER_DATA}/admin/options/users`, { uid: slaveId.value || userData.value.uid })
			.then(res => {
				tableData.value = res
				isTableLoading.value = false
			})
			.catch(() => {
				isTableLoading.value = false
			})
	}, [])


	return {
		isTableLoading: isTableLoading.value,
		getTableData,
	}
}